// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// PackagingType — source: shared/config/product_catalog.config.json § packaging_type

export const PACKAGING_TYPE_VALUES = ["box", "pallet", "bag", "drum", "bottle", "case", "crate", "carton", "can", "pouch", "sack", "container", "tube", "jar", "roll", "other"] as const;
export type PackagingType = (typeof PACKAGING_TYPE_VALUES)[number];

export const packagingTypeIcon: Record<PackagingType, string> = {
  "box": "Package",
  "pallet": "Package",
  "bag": "ShoppingBag",
  "drum": "Container",
  "bottle": "FlaskConical",
  "case": "Package",
  "crate": "Package",
  "carton": "Package",
  "can": "Container",
  "pouch": "ShoppingBag",
  "sack": "ShoppingBag",
  "container": "Container",
  "tube": "Cylinder",
  "jar": "FlaskConical",
  "roll": "Disc",
  "other": "Package",
};

